<template>
    <div class="container-fluid">
        <div class="row">

            <div class="col-10 pt-3 pb-3 bg-fafafa">

                <!-- Breadcrumb -->
                <breadcrumb />

                <div class="card card-body">

                    <h5 class="font-weight-bold m-0">Ricetta specialistica per il paziente {{ this.$route.params.CF }}</h5>

                    <p class="text-muted mb-3">
                        <small>
                            {{ form.diagnosi }}
                        </small>
                    </p>

                    <form @submit.prevent="updateRicetta" autocomplete="off">
                        <b-tabs class="mt-2" content-class="border border-top-0">
                            <b-tab title="Dati ricetta">
                                <template v-slot:title>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash ml-md-2 mt-md-1" viewBox="0 0 384 512">
                                        <path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/>
                                    </svg>                                   
                                    Dati ricetta                         
                                </template>                            
                            
                                <div class="row p-3">
                                    <div class="col-xl-12 col-lg-12">
                                        <div class="form-group">

                                            <label for="CF">Codice fiscale</label>
                                            <input type="text" class="form-control f-family-monospace" id="CF" :value="this.$route.params.CF" disabled>

                                        </div> 
                                        <div class="row">
                                            <div class="form-group col-xl-3 col-lg-3">
                                                <label for="tipo_ricetta">Tipo ricetta</label>
                                                <select class="form-control" id="tipo_ricetta" v-model="form.tipo_ricetta">
                                                    <option value="">Assistiti SSN</option>
                                                    <option :value="EE">Assicurati extra-europei in temporaneo soggiorno</option>
                                                    <option :value="UE">Assicurati europei in temporaneo soggiorno</option>
                                                    <option :value="NA">Assistiti SASN con visita ambulatoriale</option>
                                                    <option :value="ND">Assistiti SASN con visita domiciliare</option>
                                                    <option :value="NE">Assistiti da istituzioni europee</option>
                                                    <option :value="NX">Assistiti SASN extraeuropei</option>
                                                    <option :value="ST">Stranieri in temporaneo soggiorno</option>                                           
                                                </select>
                                            </div>
                                            <div class="form-group col-xl-3 col-lg-3">
                                                <label for="stato">Ricetta anonima</label>
                                                <select class="form-control" id="stato" v-model="form.oscuramento_dati">
                                                    <option :value=0 selected>No</option>  
                                                    <option :value=1>Sì</option>                                   
                                                </select>
                                            </div>                                           
                                            <div class="form-group col-xl-3 col-lg-3">
                                                <label for="stato">Tipo visita</label>
                                                <select class="form-control" id="stato" v-model="form.tipo_visita" disabled aria-readonly="true">
                                                    <option value="A" disabled>Ambulatoriale</option>                                      
                                                </select>
                                            </div>
                                            <div class="form-group col-xl-3 col-lg-3">
                                                <label for="stato">Tipologia prescrizione</label>
                                                <select class="form-control" id="indicazione_prescrizione" v-model="form.indicazione_prescrizione">
                                                    <option value="">Seleziona</option>
                                                    <option value="S">Suggerita</option>
                                                    <option value="H">Ricovero</option>                                
                                                </select>                             
                                            </div>                                            
                                        </div>                                                                                                                                                                             
                                    </div>
                                    <div class="col-xl-12 col-lg-12">
                                        <div class="form-group">

                                             
                                            <label for="pathologies" class="m-0">Quesito diagnostico (<strong class="text-danger">*</strong>):</label>
                                            <div class="row">
                                                <div class="col-xl-4 col-lg-4">
                                                    <input type="text" placeholder="🔎︎ Filtra per codice..." class="search_filter w-100 mb-1 height" v-model="filters.codice_pathology_input_search"  @keyup="getSearchCodicePathologies"  v-bind:disabled="filters.pathology_input_search.length >= 1">
                                                </div>
                                                <div class="col-xl-8 col-lg-8">
                                                    <input type="text" placeholder="🔎︎ Filtra per descrizione" class="search_filter w-100 mb-1 height" v-model="filters.pathology_input_search"  @keyup="getSearchPathologies"  v-bind:disabled="filters.codice_pathology_input_search.length >= 1">
                                                </div>                                               
                                            </div>
                                            
                                            <div class="h-max-160-px" v-if="filters.codice_pathology_input_search.length >= 3 || filters.pathology_input_search.length >= 3" style="overflow-y: auto; overflow-x: hidden;">
                                                <div class="custom-control custom-radio custom-control-inline text-truncate w-100" v-for="(pathology, index) in DB.pathologies" v-bind:key="`filter_pathology_${index}`" v-bind:class="{'border-bottom': index+1 != DB.pathologies.length}">
                                                    <input type="radio" class="custom-control-input" :id="`pathology_${pathology.descrizione}`" :value="`${pathology.codice}@${pathology.descrizione}`" v-model="form.codice">
                                                    <label class="custom-control-label" :for="`pathology_${pathology.descrizione}`" :title="`${pathology.descrizione}`">
                                                        <strong class="text-monospace">{{pathology.codice}}</strong>/{{pathology.descrizione}}
                                                    </label>

                                                </div>
                                            </div>

                                            <small class="form-text text-muted">
                                                
                                            </small>
                                                                        

                                        </div>
                                                                     
                                    </div>
                                </div>                    

                            </b-tab>
                        </b-tabs>
                        <b-tabs class="mt-2" content-class="border border-top-0"> 
                            <b-tab title="Farmaci ricetta">
                                <template v-slot:title>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash ml-md-2 mt-md-1" viewBox="0 0 384 512">
                                        <path d="M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zm32 96l320 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zM160 240l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"/>
                                    </svg> 
                                    Farmaci ricetta                       
                                </template>                            
                            
                                <div class="row p-3">
                                    <div class="col-xl-12 col-lg-12">
                                        <div class="form-group">
                                            <strong for="codice_esenzione" class="m-0 f-size-0_8-em">Ricerca codice/descrizione esenzioni regione Lazio:</strong>
                                            <div class="row">
                                                <div class="col-xl-3 col-lg-3">
                                                    <label>Tipo esenzione</label>
                                                    <select class="form-control" id="tipo_esenzione" v-model="form.tipo_esenzione">
                                                        <option value="0">- Seleziona -</option>
                                                        <option value="1">Patologia</option>
                                                        <option value="2">Malattie rare</option>
                                                        <option value="3">Invalidità e cat. prot.</option>
                                                        <option value="4">Senza tessera</option>
                                                        <option value="5">Reddito</option>
                                                        <option value="6">Regionali</option>
                                                    </select>    
                                                </div> 
                                                <div class="col-xl-3 col-lg-3 mt-3">
                                                    <input type="text" placeholder="🔎︎ Filtra per codice..." class="search_filter w-100 mb-1 height" v-model="filters.codice_esenzione_input_search"  @keyup="getSearchCodiceEsenzione" v-bind:disabled="filters.descrizione_esenzione_input_search.length >= 1 || form.tipo_esenzione == 0">
                                                </div>
                                                <div class="col-xl-6 col-lg-6 mt-3">
                                                    <input type="text" placeholder="🔎︎ Filtra per descrizione..." class="search_filter w-100 mb-1 height" v-model="filters.descrizione_esenzione_input_search"  @keyup="getSearchDescrizioneEsenzione" v-bind:disabled="filters.codice_esenzione_input_search.length >= 1 || form.tipo_esenzione == 0">
                                                </div>                                               
                                            </div>
                                            <div class="h-max-160-px" v-if="filters.codice_esenzione_input_search.length >= 3 || filters.descrizione_esenzione_input_search.length >= 3" style="overflow-y: auto; overflow-x: hidden;">
                                                <div class="custom-control custom-radio custom-control-inline text-truncate w-100" v-for="(esenzione, index) in DB.codici_esenzioni" v-bind:key="`filter_esenzione_${index}`" v-bind:class="{'border-bottom': index+1 != DB.codici_esenzioni.length}">
                                                    <input type="radio" class="custom-control-input" :id="`esenzione_${esenzione.descrizioneEsenzione}`" :value="`${esenzione.codiceEsenzione}@${esenzione.descrizioneEsenzione}`" v-model="form.codice_esenzione">
                                                    <label class="custom-control-label" :for="`esenzione_${esenzione.descrizioneEsenzione}`" :title="`${esenzione.descrizioneEsenzione}`">
                                                        <strong class="text-monospace">{{esenzione.codiceEsenzione}}</strong>/{{esenzione.descrizioneEsenzione}}
                                                    </label>

                                                </div>
                                            </div>                      

                                            <small class="form-text text-muted">
                                                
                                            </small>
                                                                        

                                        </div>
 
                                        <div class="form-group">
                                            <label for="codice_esenzione" class="m-0">AIC/Denominazione e confezione:</label>
                                            <div class="row">
                                                <div class="col-xl-4 col-lg-4">
                                                    <input type="text" placeholder="🔎︎ Filtra per AIC..." class="search_filter w-100 mb-1 height" v-model="filters.codice_prestazione_input_search"  @keyup="getSearchAic" v-bind:disabled="filters.descrizione_prestazione_input_search.length >= 1">
                                                </div>
                                                <div class="col-xl-8 col-lg-8">
                                                    <input type="text" placeholder="🔎︎ Filtra per descrizione" class="search_filter w-100 mb-1 height" v-model="filters.descrizione_prestazione_input_search"  @keyup="getSearchDescrizione" v-bind:disabled="filters.codice_prestazione_input_search.length >= 1">
                                                </div>                                               
                                            </div>
                                            
                                            <div class="h-max-160-px" v-if="filters.codice_prestazione_input_search.length >= 3 || filters.descrizione_prestazione_input_search.length >= 3" style="overflow-y: auto; overflow-x: hidden;">
                                                <div class="custom-control custom-radio custom-control-inline text-truncate w-100" v-for="(prestazione, index) in DB.codici_prestazioni" v-bind:key="`filter_prestazione_${index}`" v-bind:class="{'border-bottom': index+1 != DB.codici_prestazioni.length}">
                                                    <input type="radio" class="custom-control-input" :id="`esenzione_${prestazione.aic}`" :value="`${prestazione.aic}@${prestazione.dc}`" v-model="form.codice_prestazione" @input="populateFields($event.target.value)">
                                                    <label class="custom-control-label" :for="`esenzione_${prestazione.aic}`" :title="`${prestazione.dc}`">
                                                        <strong class="text-monospace">{{prestazione.aic}}</strong>/{{prestazione.dc}} - ({{prestazione.classe}} {{prestazione.principioAttivo}} {{prestazione.ditta}})
                                                    </label>

                                                </div>
                                            </div>                      

                                            <small class="form-text text-muted">
                                                
                                            </small>
                                                                        

                                        </div>                                        
                                    </div>                                   
                                    <div class="col-xl-12 col-lg-12">
                                        <div class="row">
                                            <div class="form-group col-xl-3 col-lg-6">
                                                <label for="quantita">Quantità</label>
                                                <input type="number" class="form-control" id="quantita" min="1" max="2" v-model="form.quantita" ref="quantita" v-bind:class="{'is-invalid': (!$v.form.quantita.required)}" >
                                            </div>                                          
                                        </div>                                                                                                                                                                                                                                                         
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4 text-center">
                                        <button type="button" class="btn btn-ifo btn-block btn-sm rounded-0" @click="addPrestazione" :disabled="form.sent == 1 || !form.codice">Aggiungi farmaco</button>
                                    </div>
                                    <div class="col-lg-4"></div>
                                </div>  
                                <div class="row" >
                                    <div class="col-lg-12 mt-3 text-left">
                                        <div class="table-responsive m-0">
                                            <table class="table table-bordered table-sm">
                                                <tbody>
                                                    <tr v-for="(prestazione, index) in ricetta_prestazioni" :key="prestazione.b_e_p">
                                                        <td colspan="6">
                                                            <div class="f-size-0_9-em" v-html="filters.split_new(prestazione.b_e_p)"></div>
                                                            <div class="table-responsive m-0">
                                                                <table class="table table-bordered table-colored table-sm table_AO">
                                                                    <thead>
                                                                        <th>ID</th>
                                                                        <th>AIC</th>
                                                                        <th>Farmaco</th>
                                                                        <th>Descrizione gruppo equivalenza</th>
                                                                        <th>Note AIFA</th>
                                                                        <th>Quantità</th>
                                                                    </thead> 
                                                                    <tbody>                                                  
                                                                        <tr v-for="(prestazione_data, index2) in prestazione.data" :key="prestazione_data.id">
                                                                            <td>{{prestazione_data.id}}</td>
                                                                            <td>{{prestazione_data.codice_prestazione}}</td>
                                                                            <td>{{prestazione_data.descrizione_prestazione}}</td>
                                                                            <td>{{prestazione_data.dge}}</td>
                                                                            <td>{{prestazione_data.note_aifa}}</td>
                                                                            <td>{{prestazione_data.quantita}}</td>
                                                                            <td>
                                                                                <a href="#" @click="removeOuterObjectsByBEP(index, index2)" v-if="prestazione.header[0].sent == 0 || !prestazione.header[0].sent">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" class="bi bi-trash ml-md-2 mt-md-1" viewBox="0 0 448 512">
                                                                                        <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/>
                                                                                    </svg>                             
                                                                                </a>                                                                
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>                                                                        
                                                                </table>  
                                                            </div>                                                               
                                                        </td>
                                                    </tr>                                             
                                                </tbody>
                                            </table> 
                                        </div>                                        
                                    </div> 
                                </div>               
                            </b-tab> 
                        </b-tabs>    
                        <b-tabs class="mt-2" content-class="border border-top-0">   
                            <b-tab title="Dati invio">
                                <template v-slot:title>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash ml-md-2 mt-md-1" viewBox="0 0 512 512">
                                        <path d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"/>
                                    </svg>                                    
                                    Dati invio                 
                                </template>                            
                            
                                <div class="row p-3">                                  
                                    <div class="col-xl-12 col-lg-12">
                                        <div class="row">
                                            <div class="form-group col-xl-8 col-lg-8">
                                                <label for="stato">Note ricetta</label>
                                                <textarea type="text" class="form-control" id="note_ricetta" v-model="form.note_ricetta"></textarea>
                                            </div> 
                                            <div class="form-group col-xl-4 col-lg-4">
                                                <label for="codice_specializzazione">Specializzazione medico</label>
                                                <select class="form-control" id="codice_specializzazione" v-model="form.codice_specializzazione">
                                                    <option :value=1>Specialista Ambulatoriale (Ex Sumai)</option>
                                                    <option :value=2>Medico consulente</option>
                                                    <option :value=3>Specialista di struttura privata accreditata</option>
                                                    <option :value=4>Dipendente dei servizi territoriali ASL</option>  
                                                    <option :value=5>Medico di medicina generale</option> 
                                                    <option :value=6>Guardia medica</option> 
                                                    <option :value=7>Ospedaliero</option> 
                                                    <option :value=8>Medico INAIL</option> 
                                                    <option :value=9>Pediatra di libera scelta</option> 
                                                    <option :value=10>Guardia medica turistica</option> 
                                                    <option :value=11>Medico di azienda ospedaliero - universitaria</option> 
                                                    <option :value=12>Altro (tirocinanti, specializzandi, etc.)</option>
                                                    <option :value=13>Altra specializzazione</option>                                                               
                                                </select>
                                            </div>                                                                                        
                                        </div> 
                                    </div>  
                                </div>                    

                            </b-tab>                             
                        </b-tabs> 
                        <div class="text-center mt-3">
                            <div v-show="validation.ko" class="alert alert-danger text-center">
                                {{validation.ko}}
                            </div>
                            <!---:disabled="loaders.creating || $v.$invalid"-->
                            <button v-show="!loaders.creating" class="btn btn-ifo mr-3" :disabled="form.sent == 1 || !form.codice || ricetta_prestazioni[0].data.length == 0">
                                <span v-show="!loaders.creating">
                                    Aggiorna ricetta
                                </span>

                                <!--<div v-show="loaders.creating" class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>-->
                            </button>
                            <button type="button" class="btn btn-ifo mr-3" @click="toggleLogin()" :disabled="form.sent == 1 || !form.codice || ricetta_prestazioni[0].data.length == 0">
                                <span v-show="!loaders.creating">
                                    Invia ricetta
                                </span>

                                <div v-show="loaders.creating" class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>
                            </button>
                            <button type="button" class="btn btn-ifo" @click="readRicetta(form.id, form.CF)" v-if="loaders.sent">Visualizza ricetta PDF</button>                                                                                          
                            <div v-if="showLogin" class="login-popup-2">
                                <div>
                                    <input type="text" v-model="username" placeholder="Username" />
                                    <br />
                                    <input type="password" v-model="password" placeholder="Password" class="mt-2" />

                                    <label class="mt-2">
                                        <input type="checkbox" v-model="rememberMe" />
                                        Ricordami
                                    </label>
                                    <br />
                                    <button @click="submitLogin" class="btn btn-ifo mt-2">Invia ricetta</button>
                                    <button @click="toggleLogin" class="btn btn-ifo mt-2 ml-3">Chiudi</button>
                                </div>    
                            </div>                                                                                   
               
                        </div>      
                    </form>
                </div>
            </div>
            <div class="col-2 h-min-100-calc-lg_logged border-left p-0">
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a href class="nav-link d-flex align-items-center justify-content-end p-3 a_bg-ifo border-bottom disabled">
                            <i class="text-muted">
                                Nessuna funzione
                            </i>
                        </a>
                    </li>
                </ul>
            </div>

        </div>  
        <!-- Ricetta PDF -->
        <vue-html2pdf

            :show-layout="false"
            :enable-download="false"
            :preview-modal="true"
            :manual-pagination="false"
            :pdf-quality="2"
            filename="ricetta"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"            
            :html-to-pdf-options = "pdf.config"
            ref = "html2PdfRicetta"

        >
            <section slot="pdf-content" class="f-size_PDF">
                <div v-for="(ricetta, index) in parsedDataRicetta" :key="index" class="pdf-container-ricetta" :class="{ 'page-break': index !== parsedDataRicetta.length - 1 }">
                    <div class="header-ricetta">
                        <div class="title-ricetta">SERVIZIO SANITARIO NAZIONALE</div>
                        <div class="title-ricetta-2">RICETTA ELETTRONICA – PROMEMORIA PER L’ASSISTITO</div>
                    </div>

                    <table class="main-table-ricetta">
                        <tr>
                            <td class="box-wide-ricetta" colspan="2">Lazio</td>
                            <td class="box-wide-ricetta-2" colspan="2">
                                <div class="text-danger">{{ ricetta.header[0].errore }}</div>
                                <div v-if="ricetta.header[0].statoProcesso == 4 || ricetta.header[0].statoProcesso == 9" class="text-danger">{{ ricetta.header[0].annullaText }}</div>
                                <NreBarcode :nre="ricetta.header[0].nre" />
                            </td>
                        </tr>
                        <tr>
                            <td class="box-patient-data mb-2 f-size-0_7-em" colspan="3">
                                COGNOME E NOME /INIZIALI DELL’ASSISTITO: {{ ricetta.header[0].oscuramento_dati == 1 ? `DATI DELL’ASSISTITO OSCURATI AI SENSI DELL’ARTICOLO 87 DEL DL 30 giugno 2003, n. 196` : ricetta_data_pdf.patient.name }}
                                <table v-if="ricetta.header[0].oscuramento_dati == 0">
                                    <tr>
                                        <td class="box-patient-data f-size-0_7-em">INDIRIZZO: {{ ricetta_data_pdf.patient.address }}</td>
                                        <td class="box-patient-data f-size-0_7-em" >CAP: {{ ricetta_data_pdf.patient.cap }}</td>
                                        <td class="box-patient-data f-size-0_7-em" >CITTÀ: {{ ricetta_data_pdf.patient.city }}</td>
                                        <td class="box-patient-data f-size-0_7-em">PROV: {{ ricetta_data_pdf.patient.province }}</td>
                                    </tr>                                    
                                </table>
                            </td>
                            <td class="box-patient-data-2" >
                                <FiscalCodeBarcode :fiscalCode="ricetta.header[0].CF" />
                            </td>
                        </tr>
                        <tr class="hr-ricetta">
                            <td class="box-patient-data f-size-0_8-em width-col-ricetta-4" colspan="4">
                                ESENZIONE: {{ ricetta.data[0].codice_esenzione ? filters.split_(ricetta.data[0].codice_esenzione, '@') : "" }}
                                &nbsp;&nbsp;
                                SIGLA PROVINCIA: RM
                                &nbsp;&nbsp;
                                CODICE ASL: 908
                                &nbsp;&nbsp;
                                DISPOSIZIONI REGIONALI: 
                            </td>

                        </tr>
                        <tr>
                            <td class="box-patient-data f-size-0_8-em width-col-ricetta-4"  colspan="4">
                                TIPOLOGIA PRESCRIZIONE(S,H): {{ ricetta_data_pdf.prescriptionInfo.type }}
                                &nbsp;&nbsp;
                                ALTRO: {{ ricetta_data_pdf.prescriptionInfo.altro }}
                                &nbsp;&nbsp;
                                PRIORITÀ PRESCRIZIONE(U,B,D,P): {{ ricetta.data[0].priorita.slice(0, 1) != 0 ? ricetta.data[0].priorita.slice(0, 1) : "" }}
                            </td>
                        </tr>
                    </table>

                    <table class="prescription-table-ricetta">
                        <thead>
                            <tr>
                                <th colspan="2" class="left-align-ricetta"><span>PRESCRIZIONE</span></th>
                                <th class="center-align-ricetta"><span>QTA</span></th>
                                <th class="center-align-ricetta"><span>NOTA</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(prestazione, i) in ricetta.data" :key="i">
                            <!--<tr v-for="(item, index) in ricetta_data_pdf.prescriptions" :key="index">-->
                                <td colspan="2" class="left-align-ricetta f-size-0_8-em p-2">{{ prestazione.codice_prestazione }} ( {{ prestazione.codice_cur }} ) {{ prestazione.descrizione_prestazione }}</td>
                                <td class="center-align-ricetta f-size-0_8-em p-2">{{ prestazione.quantita }}</td>
                                <td class="center-align-ricetta f-size-0_8-em p-2">{{ prestazione.note }}</td>
                            </tr>                           
                        </tbody>
                    </table>

                    <div class="footer-ricetta f-size-0_8-em">
                        QUESITO DIAGNOSTICO: {{  filters.split_(ricetta.header[0].codice, '@') }} - {{  filters.split__(ricetta.header[0].codice, '@') }}<br />
                        N. PRESTAZIONI: {{ ricetta.data.length }}
                        &nbsp;&nbsp; TIPO RICETTA: {{  ricetta.header[0].tipo_ricetta ? ricetta.header[0].tipo_ricetta : "SSN" }} 
                        &nbsp;&nbsp; DATA: {{ ricetta.header[0].data_nre | data_slash }}
                        &nbsp;&nbsp; CODICE FISCALE DEL MEDICO: PROVAX00X00X000Y<br />
                        CODICE AUTENTICAZIONE: {{ ricetta.header[0].codAutenticazione }}
                        &nbsp;&nbsp; COGNOME E NOME DEL MEDICO: Pallino Pinco<br />

                        <p class="note-ricetta f-size-0_8-em mt-1 text-center">
                            Rilasciato ai sensi dell’art.11, comma 16 del DL 31 mag 2010,n.78 e dell’art.1, comma 4 del DM 2 nov 2011
                        </p>                                 
                    </div>
                </div>
            </section>
        </vue-html2pdf>  
        
        <vue-html2pdf

            :show-layout="false"
            :enable-download="false"
            :preview-modal="true"
            :manual-pagination="false"
            :pdf-quality="2"
            filename="ricetta"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"            
            :html-to-pdf-options = "pdf.config"
            ref = "html2PdfRicettaF"

        >
            <section slot="pdf-content" class="f-size_PDF">
                <div v-for="(ricetta, index) in parsedDataRicettaF" :key="index" class="pdf-container-ricetta" :class="{ 'page-break': index !== parsedDataRicettaF.length - 1 }">
                    <div class="header-ricetta">
                        <div class="title-ricetta">SERVIZIO SANITARIO NAZIONALE</div>
                        <div class="title-ricetta-2">RICETTA ELETTRONICA – PROMEMORIA PER L’ASSISTITO</div>
                    </div>

                    <table class="main-table-ricetta">
                        <tr>
                            <td class="box-wide-ricetta" colspan="2">Lazio</td>
                            <td class="box-wide-ricetta-2" colspan="2">
                                <div class="text-danger">{{ ricetta.header[0].errore }}</div>
                                <div v-if="ricetta.header[0].statoProcesso == 4 || ricetta.header[0].statoProcesso == 9" class="text-danger">{{ ricetta.header[0].annullaText }}</div>
                                <NreBarcode :nre="ricetta.header[0].nre" />
                            </td>
                        </tr>
                        <tr>
                            <td class="box-patient-data mb-2 f-size-0_8-em" colspan="3">
                                COGNOME E NOME /INIZIALI DELL’ASSISTITO: {{ ricetta.header[0].oscuramento_dati == 1 ? `DATI DELL’ASSISTITO OSCURATI AI SENSI DELL’ARTICOLO 87 DEL DL 30 giugno 2003, n. 196` : ricetta_data_pdf.patient.name }}
                                <table v-if="ricetta.header[0].oscuramento_dati == 0">
                                    <tr>
                                        <td class="box-patient-data f-size-0_8-em">INDIRIZZO: {{ ricetta_data_pdf.patient.address }}</td>
                                        <td class="box-patient-data f-size-0_8-em" >CAP: {{ ricetta_data_pdf.patient.cap }}</td>
                                        <td class="box-patient-data f-size-0_8-em" >CITTÀ: {{ ricetta_data_pdf.patient.city }}</td>
                                        <td class="box-patient-data f-size-0_8-em">PROV: {{ ricetta_data_pdf.patient.province }}</td>
                                    </tr>                                    
                                </table>
                            </td>
                            <td class="box-patient-data-2" >
                                <FiscalCodeBarcode :fiscalCode="ricetta.header[0].CF" />
                            </td>
                        </tr>
                        <tr class="hr-ricetta">
                            <td class="box-patient-data f-size-0_8-em width-col-ricetta-4" colspan="4">
                                ESENZIONE: {{ ricetta.data[0].codice_esenzione ? filters.split_(ricetta.data[0].codice_esenzione, '@') : "" }}
                                &nbsp;&nbsp;
                                SIGLA PROVINCIA: RM
                                &nbsp;&nbsp;
                                CODICE ASL: 908
                                &nbsp;&nbsp;
                                DISPOSIZIONI REGIONALI: 
                            </td>

                        </tr>
                        <tr>
                            <td class="box-patient-data f-size-0_8-em width-col-ricetta-4"  colspan="4">
                                TIPOLOGIA PRESCRIZIONE(S,H): 
                                &nbsp;&nbsp;
                                ALTRO: 
                                &nbsp;&nbsp;
                                PRIORITÀ PRESCRIZIONE(U,B,D,P): 
                            </td>
                        </tr>
                    </table>

                    <table class="prescription-table-ricetta">
                        <thead>
                            <tr>
                                <th colspan="2" class="left-align-ricetta"><span>PRESCRIZIONE</span></th>
                                <th class="center-align-ricetta"><span>QTA</span></th>
                                <th class="center-align-ricetta"><span>NOTA</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(prestazione, i) in ricetta.data" :key="i">
                            <!--<tr v-for="(item, index) in ricetta_data_pdf.prescriptions" :key="index">-->
                                <td colspan="2" class="left-align-ricetta f-size-0_8-em p-2">{{ prestazione.codice_prestazione }} {{ prestazione.descrizione_prestazione }}</td>
                                <td class="center-align-ricetta f-size-0_8-em p-2">{{ prestazione.quantita }}</td>
                                <td class="center-align-ricetta f-size-0_8-em p-2">--</td>
                            </tr>                           
                        </tbody>
                    </table>

                    <div class="footer-ricetta f-size-0_8-em">
                        QUESITO DIAGNOSTICO: {{  filters.split_(ricetta.header[0].codice, '@') }} - {{  filters.split__(ricetta.header[0].codice, '@') }}<br />
                        N. PRESTAZIONI: {{ ricetta.data.length }}
                        &nbsp;&nbsp; TIPO RICETTA: {{  ricetta.header[0].tipo_ricetta ? ricetta.header[0].tipo_ricetta : "SSN" }} 
                        &nbsp;&nbsp; DATA: {{ ricetta.header[0].data_nre | data_slash }}
                        &nbsp;&nbsp; CODICE FISCALE DEL MEDICO: {{ ricetta_data_pdf.doctor.cf }}<br />
                        CODICE AUTENTICAZIONE: {{ ricetta.header[0].codAutenticazione }}
                        &nbsp;&nbsp; COGNOME E NOME DEL MEDICO: {{ ricetta_data_pdf.doctor.name }}<br />

                        <p class="note-ricetta f-size-0_8-em mt-1 text-center">
                            Rilasciato ai sensi dell’art.11, comma 16 del DL 31 mag 2010,n.78 e dell’art.1, comma 4 del DM 2 nov 2011
                        </p>                                 
                    </div>
                </div>
            </section>
        </vue-html2pdf>             
        
    </div>
</template>

<script>

    import { 
        required
    } from "vuelidate/lib/validators"

    import moment from "moment"
    import VueHtml2pdf from 'vue-html2pdf'
    import NreBarcode from "@/components/NreBarcode.vue";
    import FiscalCodeBarcode from "@/components/FiscalCodeBarcode.vue";    

    export default {
        data() {
            return {
                showLogin:              false,
                optionsList:            "0",   
                array_first:            [],                     
                ricetta_prestazioni:    [], 
                arrayCheckFirst:        [],
                countId:                1,
                calendar: {
                    config: {
                        minDate:      moment().add(1, "days").format("YYYY-MM-DD")                    
                    }
                },               
                DB: {
                    patient:                    null,
                    pathologies:                [],
                    codici_esenzioni:           [],
                    codici_prestazioni:         []
                },
                local: {
                    therapy:     {},
                    pathologies: []
                },
                form: {
                    id:                         0,
                    diagnosi:                   null,
                    codice:                     null,
                    tipo_ricetta:               "",
                    tipo_visita:                "A",
                    oscuramento_dati:           0,
                    indicazione_prescrizione:   "S",
                    tipo_esenzione:             0,
                    codice_esenzione:           null,
                    codice_prestazione:         null,
                    codice_cur:                 null,
                    branca:                     null,
                    branca_descrizione:         null,
                    quantita:                   1,
                    tipo_accesso:               3,
                    classe_priorita:            "0",
                    codice_specializzazione:    7,
                    tipo_prescrizione:          "P",
                    note:                       null,
                    ricetta_rossa:              0,
                    note_ricetta:               null,
                    sendRicettaServer:          0,
                    nre:                        "",
                    CF:                         this.$route.params.CF,
                    dge:                        null,
                    note_aifa:                  null
                },
                validation: {
                    ko: false
                },
                loaders: {
                    creating: false,
                    reading:  true,
                    sent:     false  
                },
                utility: {
                    today: moment().format("YYYY-MM-DD")
                },
                parsedDataRicetta: [],
                parsedDataRicettaF: [],
                ricetta_data_pdf: {
                    patient: {
                        name: '',
                        address: '',
                        cap: '',
                        city: '',
                        province: '',
                    },
                    prescriptions: [],
                    prescriptionInfo: {
                        type: '',
                        altro: '—',
                        priority: '',
                        confezioni: 2,
                        tipo: '',
                        date: '',
                        nre:  ''  
                    },
                    doctor: {
                        name: '',
                        cf: '',
                    },
                    data: {
                        box1: '',
                        box2: '',
                        field9: '',
                        exemption: '',
                        siglaProvincia: '',
                        codiceASL: '',
                        disposizioniRegionali: '',
                        qd: '',
                        authCode: '',
                    }                   
                },
                ricetta_data_pdf_f: {
                    patient: {
                        name: '',
                        address: '',
                        cap: '',
                        city: '',
                        province: '',
                    },
                    prescriptions: [],
                    prescriptionInfo: {
                        type: '',
                        altro: '—',
                        priority: '',
                        confezioni: 2,
                        tipo: '',
                        date: '',
                        nre:  ''  
                    },
                    doctor: {
                        name: '',
                        cf: '',
                    },
                    data: {
                        box1: '',
                        box2: '',
                        field9: '',
                        exemption: '',
                        siglaProvincia: '',
                        codiceASL: '',
                        disposizioniRegionali: '',
                        qd: '',
                        authCode: '',
                    }                   
                },                
                pdf: {
                    config: {

                        margin: 10,

                        jsPDF: {
                            //unit: 'in',
                            format: 'a4',
                            orientation: 'portrait'
                        },

                        filename: "ricetta"

                    }
                },                
                filters: {
                    codice_pathology_input_search: "",
                    pathology_input_search: "",
                    codice_esenzione_input_search: "",
                    descrizione_esenzione_input_search: "",
                    codice_prestazione_input_search: "",
                    descrizione_prestazione_input_search: "",
                    replace: function (st, rep, repWith) {
                        const result = st.split(rep).join(repWith)
                        return result;
                    },
                    split_: function (st, rep) {
                        let result = st.split(rep)
                        result = result[0]
                        return result;
                    },    
                    split__: function (st, rep) {
                        let result = st.split(rep)
                        result = result[1]
                        return result;
                    },                                         
                    split_new: function (st) {
                        let result = st                     
                        const esenzione = st != null ? st : "-"
                        const esenzione_title = this.split__(esenzione, "@")
                        result = `ESENZIONE: <a href="#" title="${esenzione_title ? esenzione_title : ""}">${this.split_(esenzione, "@")}</a>`
                        return result;
                    }                                 
                }
            }
        },
        validations() {
            return {
                form: {                
                    codice: {
                        required
                    },
                    codice_cur: {
                        required
                    }, 
                    branca: {
                        required
                    },   
                    quantita: {
                        required
                    },                                       
                    classe_priorita : {
                        required
                    },                                     
                }
            }
        },
        components: {
            VueHtml2pdf,
            NreBarcode,
            FiscalCodeBarcode
        },              
        methods: {
            createPDF(ref) {
                this.$refs[ref].generatePdf()   
            },               
            async readRicetta(id, CF) {
                try {

                    this.parsedDataRicettaF = []

                    const patient = await this.axios.get(`user/ricetta/read/detail_f/${id}/${CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    const ricetta = patient.data

                    const jsonData = JSON.parse(ricetta.data_send)


                    for(const arr of jsonData) {
                        if(arr.header[0].sent == 1){
                            this.parsedDataRicettaF.push(arr)
                        }                          
                    } 

                    this.ricetta_data_pdf_f.doctor.name = ricetta.user.surname + " " + ricetta.user.name
                    this.ricetta_data_pdf_f.doctor.cf = ricetta.cfMedico

                    //const jsonOtherData = JSON.parse(ricetta.other_data)    
                    

                    //const arrayData = jsonData[0].data[0]
                    const arrayOtherData = jsonData[0].header[0]
                    const arrayPrescriptions = jsonData[0].data

                    this.ricetta_data_pdf_f.prescriptionInfo.priority = jsonData[0].data[0].priorita

                    for(const prescription of arrayPrescriptions) {

                        this.ricetta_data_pdf_f.prescriptions.push({
                            details: prescription.codice_prestazione + " (" + prescription.codice_cur + ") " + prescription.descrizione_prestazione,
                            qta: prescription.quantita,
                            nota: prescription.note
                        })
                    }   

                    this.ricetta_data_pdf_f.prescriptionInfo.type = arrayOtherData.indicazione_prescrizione
                    this.ricetta_data_pdf_f.prescriptionInfo.altro = '—'
                    this.ricetta_data_pdf_f.prescriptionInfo.nre = arrayOtherData.nre  

                    

                    this.ricetta_data_pdf_f.patient.name = ricetta.patient.surname + " " + ricetta.patient.name
                    this.ricetta_data_pdf_f.patient.address = ricetta.patient.address
                    this.ricetta_data_pdf_f.patient.cap = ""
                    this.ricetta_data_pdf_f.patient.city = ""
                    this.ricetta_data_pdf_f.patient.province = ""
                    

                    this.createPDF("html2PdfRicettaF")
                }
                catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })

                }

            },   
            toggleLogin() {
                this.showLogin = !this.showLogin;          
            },
            submitLogin(event) {
                if (this.username && this.password) {
                    this.showLogin = false;
                    if (this.rememberMe) {
                        localStorage.setItem('rememberedLogin', 'true');
                        localStorage.setItem('username', this.username);
                        localStorage.setItem('password', this.password);
                    } else {
                        localStorage.removeItem('rememberedLogin');
                        localStorage.removeItem('username');
                        localStorage.removeItem('password');
                    }
                    this.sendRicettaServer(1, this.username, this.password);
                } else {
                    event.preventDefault();
                }
            },                                                         
            sendRicettaServer(val, username, password){
                if(val == 1){
                    this.form.sendRicettaServer = 1
                }
                this.updateRicetta(username, password)
            },            
            countDataPerBEP(arr) {
                const result = {};

                for (const entry of arr) {
                    const key = entry.b_e_p;
                    const count = Array.isArray(entry.data) ? entry.data.length : 0;

                    if (!result[key]) {
                        result[key] = 0;
                    }

                    result[key] += count;
                }

                // Convertiamo il risultato in un array
                return Object.entries(result).map(([b_e_p, count]) => ({ b_e_p, count }));              
            },
            mergeOuterObjectsByBEP(arr, max = 8) {
                try {
                    const grouped = {};
                    for (const item of arr) {
                        const key = JSON.stringify({ b_e_p: item.b_e_p, header: item.header });

                        if (!grouped[key]) {
                            grouped[key] = {
                                b_e_p: item.b_e_p,
                                header: item.header,
                                data: []
                            };
                        }

                        grouped[key].data = grouped[key].data.concat(item.data || []);
                    }

                    const result = [];

                    for (const { b_e_p, header, data } of Object.values(grouped)) {
                        for (let i = 0; i < data.length; i += max) {
                            result.push({
                                b_e_p,
                                header,
                                data: data.slice(i, i + max)
                            });
                        }
                    }
                    

                    return result;
                    // Raggruppa tutti i data per b_e_p
                    /*for (const item of arr) {
                        const key = item.b_e_p;
                        if (!grouped[key]) {
                            grouped[key] = [];
                        }
                        grouped[key] = grouped[key].concat(item.data || []);
                        
                    }

                    // Suddivide i data in gruppi da max elementi
                    const result = [];

                    for (const [b_e_p, dataArray] of Object.entries(grouped)) {
                        for (let i = 0; i < dataArray.length; i += max) {
                            result.push({
                                b_e_p,
                                data: dataArray.slice(i, i + max)
                            });
                        }
                    }

                    return result;*/                    
                    /*const merged = Object.values(
                        arr.reduce((acc, item) => {
                            const key = item.b_e_p;
                            if (!acc[key]) {
                                acc[key] = { b_e_p: key, data: [] };
                            }

                            acc[key].data = acc[key].data.concat(item.data);
                            return acc;
                        }, {})
                    );

                    return merged*/

                } catch(e) {
                
                     this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                }               
            }, 
            removeOuterObjectsByBEP(position, id) {
                try {
                    let data = this.ricetta_prestazioni[position].data;

                    if (!Array.isArray(data)) {
                    throw new Error(`ricetta_prestazioni[${position}].data non è un array`);
                    }

                    if (id < 0 || id >= data.length) {
                    throw new Error(`Indice ${id} fuori range, data.length = ${data.length}`);
                    }

                    // elimina l'elemento
                    data.splice(id, 1);

                    // aggiorno la copia
                    this.array_first = [...this.ricetta_prestazioni];

                } catch (e) {
                    console.error(e);
                    this.$toast.open({
                    message: e.message || e.response?.data?.msg,
                    type: `error`
                    });
                }
            },      
            removeInnerObjectsByBEP(position) {
                if(this.ricetta_prestazioni[position].data.length == 0){
                    this.ricetta_prestazioni.splice(position, 1);
                    this.array_first[position].splice(position, 1);
                }
                this.array_first = this.ricetta_prestazioni
            },            
            hasPrestazioniDuplicate(arr) {
                const seen = new Set();
                for (const entry of arr) {
                    for (const entryData of entry || []) {
                        for (const item of entryData.data || []) {

                            const codice_prestazione = item.codice_prestazione || "";
                            const descrizione_prestazione = item.descrizione_prestazione || "";
                            const codice_cur = item.codice_cur || "";

                            const key = `${codice_prestazione}::${descrizione_prestazione}::${codice_cur}`;

                            if (seen.has(key)) {
                                this.arrayCheckFirst = []
                                this.arrayCheckFirst.push(this.ricetta_prestazioni)                                
                                return true;
                            }

                            seen.add(key);
                        }
                    }    
                }

                return false;            
            },                        
            addPrestazione() {
                var codice_ntrrl = this.form.codice_prestazione
                codice_ntrrl = codice_ntrrl.split("@")

                this.arrayCheckFirst.push([{
                        b_e_p: this.form.branca + "§" + this.form.branca_descrizione + "#" + this.form.codice_esenzione + "#" + this.form.classe_priorita, 
                        data: [{
                            branca:                     this.form.branca,
                            branca_descrizione:         this.form.branca_descrizione,
                            codice_esenzione:           this.form.codice_esenzione,
                            id:                         this.countId, 
                            codice_prestazione:         codice_ntrrl[0],
                            descrizione_prestazione:    codice_ntrrl[1],
                            codice_cur:                 this.form.codice_cur,
                            quantita:                   this.form.quantita,
                            tipo_accesso:               this.form.tipo_accesso,
                            note:                       this.form.note                              
                        }],
                        header: [{
                            priorita:                   this.form.classe_priorita,
                            codice:                     this.form.codice,             
                            tipo_ricetta:               this.form.tipo_ricetta,
                            tipo_visita:                this.form.tipo_visita,
                            oscuramento_dati:           this.form.oscuramento_dati,
                            indicazione_prescrizione:   this.form.indicazione_prescrizione,
                            codice_specializzazione:    this.form.codice_specializzazione,
                            tipo_prescrizione:          this.form.tipo_prescrizione,
                            ricetta_rossa:              this.form.ricetta_rossa,
                            note_ricetta:               this.form.note_ricetta,
                            sent:                       this.form.sendRicettaServer,
                            codice_esenzione:           this.form.codice_esenzione,
                            id:                         this.$route.params.id,         
                            CF:                         this.$route.params.CF                              
                        }]     
                    }] 

                )

                if(!this.hasPrestazioniDuplicate(this.arrayCheckFirst)){              
                    this.array_first.push({ 
                        b_e_p: this.form.branca + "§" + this.form.branca_descrizione + "#" + this.form.codice_esenzione + "#" + this.form.classe_priorita, 
                        data: [{
                            branca:                     this.form.branca,
                            branca_descrizione:         this.form.branca_descrizione,
                            codice_esenzione:           this.form.codice_esenzione,
                            priorita:                   this.form.classe_priorita,
                            id:                         this.countId, 
                            codice_prestazione:         codice_ntrrl[0],
                            descrizione_prestazione:    codice_ntrrl[1],
                            codice_cur:                 this.form.codice_cur,
                            quantita:                   this.form.quantita,
                            tipo_accesso:               this.form.tipo_accesso,
                            note:                       this.form.note                                          
                        }],
                        header: [{
                            priorita:                   this.form.classe_priorita,
                            codice:                     this.form.codice,             
                            tipo_ricetta:               this.form.tipo_ricetta,
                            tipo_visita:                this.form.tipo_visita,
                            oscuramento_dati:           this.form.oscuramento_dati,
                            indicazione_prescrizione:   this.form.indicazione_prescrizione,
                            codice_specializzazione:    this.form.codice_specializzazione,
                            tipo_prescrizione:          this.form.tipo_prescrizione,
                            ricetta_rossa:              this.form.ricetta_rossa,
                            note_ricetta:               this.form.note_ricetta,
                            sent:                       this.form.sendRicettaServer,
                            codice_esenzione:           this.form.codice_esenzione,
                            CF:                         this.$route.params.CF                              
                        }]                            
                    })

                    this.ricetta_prestazioni = this.mergeOuterObjectsByBEP(this.array_first)

                    this.countId = this.countId + 1
                    this.form.note = null   
                    this.form.quantita = 1  
                    this.form.codice_cur  = null
                    this.form.branca  = null          

                } else {
                     const message = "Prestazione già aggiunta"
                     this.$toast.open({
                        message,
                        type: `error`
                    })                   
                }

            },   
            async backRicetta(nre, CF_medico) {

                this.loaders.creating = true
                this.validation.ko    = false
                this.form.CF          = this.$route.params.CF
                const id              = this.$route.params.id

                try {
                    const ricetta = await this.axios.post(`user/ricetta/annulla`, {nre, CF_medico, id}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: ricetta.data.msg,
                        type:   `success`
                    })

                    this.$router.go(this.$router.currentRoute)
                }catch(e) {

                    const message = e.response.data.msg

                    this.$toast.open({
                        message,
                        type: `error`
                    })

                }

                
                
            },             
            async updateRicetta(username, password) {

                this.loaders.creating = true
                this.validation.ko    = false
                this.form.CF          = this.$route.params.CF

                var arrayOtherData = []
                arrayOtherData.push({
                    codice:                     this.form.codice,             
                    tipo_ricetta:               this.form.tipo_ricetta,
                    tipo_visita:                this.form.tipo_visita,
                    oscuramento_dati:           this.form.oscuramento_dati,
                    indicazione_prescrizione:   this.form.indicazione_prescrizione,
                    codice_specializzazione:    this.form.codice_specializzazione,
                    tipo_prescrizione:          this.form.tipo_prescrizione,
                    note_ricetta:               this.form.note_ricetta,
                    sent:                       this.form.sendRicettaServer,
                    codice_esenzione:           this.form.codice_esenzione,
                    CF:                         this.$route.params.CF                      
                })

                this.ricetta_prestazioni[0].header = []

                this.ricetta_prestazioni[0].header.push({
                    priorita:                   this.form.classe_priorita,
                    codice:                     this.form.codice,             
                    tipo_ricetta:               this.form.tipo_ricetta,
                    tipo_visita:                this.form.tipo_visita,
                    oscuramento_dati:           this.form.oscuramento_dati,
                    indicazione_prescrizione:   this.form.indicazione_prescrizione,
                    codice_specializzazione:    this.form.codice_specializzazione,
                    tipo_prescrizione:          this.form.tipo_prescrizione,
                    note_ricetta:               this.form.note_ricetta,
                    sent:                       this.form.sendRicettaServer,
                    codice_esenzione:           this.form.codice_esenzione,
                    id:                         this.$route.params.id,      
                    CF:                         this.$route.params.CF                      
                })

                var ricetta_prestazioni_data = []

                ricetta_prestazioni_data.push(this.ricetta_prestazioni)

                try {
                    if(ricetta_prestazioni_data[0].length <= 0){
                        const message = "Aggiungere almeno una prestazione"

                        this.$toast.open({
                            message,
                            type: `error`
                        })

                        this.validation.ko    = message
                        this.loaders.creating = false
                    } else {                       

                        const ricetta = await this.axios.post(`user/ricetta/update_f`, {ricetta_prestazioni_data, username, password}, {
                            headers:{
                                Authorization: `bearer ${this.$store.state.auth.token}`
                            }
                        })

                        this.$toast.open({
                            message: ricetta.data.msg,
                            type:   `success`
                        })

                        this.$router.go(this.$router.currentRoute)
                        //this.$router.go(-1)
                    }   

                }
                catch(e) {

                    const message = e.response.data.msg

                    this.$toast.open({
                        message,
                        type: `error`
                    })

                    this.validation.ko    = message
                    this.loaders.creating = false

                }

                
                
            },
            async readPatient() {

                const {
                    id
                } = this.$route.params

                try {

                    const patient = await this.axios.get(`user/ricetta/read/detail_f/${id}/${this.$route.params.CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.DB.patient = patient.data   
                    const ricetta = patient.data

                    const jsonData = JSON.parse(ricetta.data_send)  
                    //const jsonOtherData = JSON.parse(ricetta.other_data)    
                    

                    //const arrayData = jsonData[0].data[0]
                    const arrayOtherData = jsonData[0].header[0]

                    this.form.diagnosi =                    ricetta.diagnosi_codice + " - " + ricetta.diagnosi_descrizione
                    this.form.tipo_prescrizione =           arrayOtherData.tipo_prescrizione
                    this.form.indicazione_prescrizione =    arrayOtherData.indicazione_prescrizione
                    this.form.ricetta_rossa =               arrayOtherData.ricetta_rossa
                    this.form.CF =                          arrayOtherData.CF
                    this.form.codice_specializzazione =     arrayOtherData.codice_specializzazione
                    this.form.oscuramento_dati =            arrayOtherData.oscuramento_dati
                    this.form.tipo_visita =                 arrayOtherData.tipo_visita
                    this.form.tipo_ricetta =                arrayOtherData.tipo_ricetta
                    this.form.codice =                      arrayOtherData.codice
                    this.form.note_ricetta =                arrayOtherData.note_ricetta
                    this.form.sent =                        arrayOtherData.sent
                    this.form.nre =                         arrayOtherData.nre
                    this.form.id =                          ricetta.id        
                    
                    if(ricetta.sent == 1){
                        this.loaders.sent = true
                    }

                    for(const data_ of jsonData) {
                        const error = data_.header[0].errore ? "ERRORE INVIO" : ""
                        const errorDetailContainer = data_.header[0].dettagliErrore
                        const errorDetail = data_.header[0].errore ? errorDetailContainer.codEsito + " - " + errorDetailContainer.esito  + " - Tipo errore:" + errorDetailContainer.tipoErrore : ""
                        const annullaText = data_.header[0].statoProcesso == 4 || data_.header[0].statoProcesso == 9 ? data_.header[0].annullaText : "" 

                        for(const data of data_.data) {

                            this.array_first.push({     
                                b_e_p:data.codice_esenzione, 
                                data: [{
                                    codice_esenzione:               data.codice_esenzione,       
                                    priorita:                       data.priorita,
                                    id:                             data.id, 
                                    codice_prestazione:             data.codice_prestazione, 
                                    descrizione_prestazione:        data.descrizione_prestazione,    
                                    note_aifa:                      data.note_aifa,
                                    dge:                            data.dge,
                                    tipo_accesso:                   data.tipo_accesso,               
                                    quantita:                       data.quantita 
                                }],
                                header: [{
                                    codice:                         this.form.codice,             
                                    tipo_ricetta:                   this.form.tipo_ricetta,
                                    tipo_visita:                    this.form.tipo_visita,
                                    oscuramento_dati:               this.form.oscuramento_dati,
                                    indicazione_prescrizione:       this.form.indicazione_prescrizione,
                                    codice_specializzazione:        this.form.codice_specializzazione,
                                    tipo_prescrizione:              this.form.tipo_prescrizione,
                                    ricetta_rossa:                  this.form.ricetta_rossa,
                                    note_ricetta:                   this.form.note_ricetta,
                                    sent:                           data_.header[0].sent,
                                    codice_esenzione:               this.form.codice_esenzione,
                                    CF:                             this.$route.params.CF,
                                    id:                             this.form.id,
                                    nre:                            data_.header[0].nre,
                                    error:                          error,
                                    errorDetail:                    errorDetail,
                                    annullaText:                    annullaText                           
                                }]                                                   
                            })
                        }   
                    }  

                    this.ricetta_prestazioni = this.mergeOuterObjectsByBEP(this.array_first)

                }
                catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })

                    this.$router.go(-1)

                }
                finally {
                    this.loaders.reading = false
                }

            },        
            async getSearchCodicePathologies() {
                const pathologies = await this.axios.get(`user/ricetta/read/codice_icd9/search/${this.filters.codice_pathology_input_search}`, {
                    headers:{
                        Authorization: `bearer ${this.$store.state.auth.token}`
                    }
                })

                const data = await pathologies.data;
                this.DB.pathologies = data    

            },            
            async getSearchPathologies() {
                    const pathologies = await this.axios.get(`user/ricetta/read/icd9/search/${this.filters.pathology_input_search}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    const data = await pathologies.data;
                    this.DB.pathologies = data    

            }, 
            async getSearchCodiceEsenzione() {
                const codici = await this.axios.get(`user/ricetta/read/codice_esenzione/search/${this.filters.codice_esenzione_input_search}/${this.form.tipo_esenzione}`, {
                    headers:{
                        Authorization: `bearer ${this.$store.state.auth.token}`
                    }
                })

                const data = await codici.data;
                this.DB.codici_esenzioni = data   

            },
            async getSearchDescrizioneEsenzione() {
                const descrizioni = await this.axios.get(`user/ricetta/read/descrizione_esenzione/search/${this.filters.descrizione_esenzione_input_search}/${this.form.tipo_esenzione}`, {
                    headers:{
                        Authorization: `bearer ${this.$store.state.auth.token}`
                    }
                })

                const data = await descrizioni.data;
                this.DB.codici_esenzioni = data    

            },            
            async getSearchAic() {
                const codici = await this.axios.get(`user/ricetta/read/aic/search/${this.filters.codice_prestazione_input_search}`, {
                    headers:{
                        Authorization: `bearer ${this.$store.state.auth.token}`
                    }
                })

                const data = await codici.data;
                this.DB.codici_prestazioni = data    

            },
            async getSearchDescrizione() {
                const descrizioni = await this.axios.get(`user/ricetta/read/descrizione_farmaco/search/${this.filters.descrizione_prestazione_input_search}`, {
                    headers:{
                        Authorization: `bearer ${this.$store.state.auth.token}`
                    }
                })

                const data = await descrizioni.data;
                this.DB.codici_prestazioni = data    

            },            
            async getDataPrestazione(val) {
                const prestazione = await this.axios.get(`user/ricetta/read/dge/search/${val}`, {
                    headers:{
                        Authorization: `bearer ${this.$store.state.auth.token}`
                    }
                })

                const data = await prestazione.data[0]
                this.form.dge = data.dge
                this.form.note_aifa = data.nota

            },             
            populateFields(val){
                if(val){
                    val = val.split("@")
                    this.getDataPrestazione(val[0])
                }
            },
            changeFieldsPriorita(){
                switch (this.form.tipo_accesso) {
                    case 1:
                        this.optionsList = '<option :value="0">Seleziona</option><option :value="B">B -Entro 10 giorni</option><option :value="D">D -Entro 30 (visite), entro 60 giorni (visite strumentali)</option><option :value="P">P -Senza priorità</option><option :value="U">U -Nel più breve tempo possibile, comunque, se differibile, entro 72 ore</option>'
                        break;
                    case 0:
                        this.optionsList = '<option :value="0">Seleziona</option><option :value="A">A -Altro</option>'
                        break;
                    case 3:
                        this.optionsList = '<option :value="0">Seleziona</option><option :value="A">A -Altro</option>'
                        break;
                }
            }                                     
        },
        watch: {
            'form.codice'(newValue) {
                // Questa funzione viene chiamata ogni volta che form.codice cambia.
                if (newValue) {
                    // Resetta i campi di ricerca.
                    // Questo farà sì che il v-if del div dei risultati diventi falso.
                    this.filters.codice_pathology_input_search = '';
                    this.filters.pathology_input_search = '';
                }
            },
            'form.codice_esenzione'(newValue) {
                // Questa funzione viene chiamata ogni volta che form.codice cambia.
                if (newValue) {
                    // Resetta i campi di ricerca.
                    // Questo farà sì che il v-if del div dei risultati diventi falso.
                    this.filters.codice_esenzione_input_search = '';
                    this.filters.descrizione_esenzione_input_search = '';
                }
            },            
            'form.codice_prestazione'(newValue) {
                // Questa funzione viene chiamata ogni volta che form.codice cambia.
                if (newValue) {
                    // Resetta i campi di ricerca.
                    // Questo farà sì che il v-if del div dei risultati diventi falso.
                    this.filters.codice_prestazione_input_search = '';
                    this.filters.descrizione_prestazione_input_search = '';
                }
            },   
            'form.CF'(newValue) {
                // Questa funzione viene chiamata ogni volta che form.codice cambia.
                if (newValue) {
                    // Resetta i campi di ricerca.
                    // Questo farà sì che il v-if del div dei risultati diventi falso.
                    this.filters.codice_fiscale_input_search = '';
                    this.filters.nome_paziente_input_search = '';
                }
            }    
        },          
        mounted() {
            this.readPatient()
        }         
    }

</script>